import React, { useEffect, useRef, useState } from "react";
import { dataInputCompleta } from "../../services/utilitarios";

interface InputDataNativaProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "type"> {
    value: string;
    onChange: (valor: string) => void;
}

const TECLAS_DE_NAVEGACAO = ["Tab", "Enter", "Escape"];

export function InputDataNativa({ value, onChange, onBlur, onKeyDown, ...rest }: InputDataNativaProps) {
    const [texto, setTexto] = useState(value);
    const digitando = useRef(false);

    useEffect(() => {
        setTexto(value);
    }, [value]);

    const aplicar = (digitado: string) => {
        digitando.current = false;
        if (digitado === "" || dataInputCompleta(digitado)) {
            if (digitado !== value) onChange(digitado);
        } else {
            setTexto(value);
        }
    };

    return (
        <input
            {...rest}
            type="date"
            value={texto}
            onKeyDown={(e) => {
                if (e.key === "Enter") aplicar(e.currentTarget.value);
                else if (!TECLAS_DE_NAVEGACAO.includes(e.key)) digitando.current = true;
                onKeyDown?.(e);
            }}
            onChange={(e) => {
                const digitado = e.target.value;
                setTexto(digitado);
                if (!digitando.current && (digitado === "" || dataInputCompleta(digitado))) onChange(digitado);
            }}
            onBlur={(e) => {
                aplicar(e.currentTarget.value);
                onBlur?.(e);
            }}
        />
    );
}
